var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"pt-16",attrs:{"id":"spec"}},[_c('vue-simple-markdown',{attrs:{"source":_vm.specification}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }